import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatWindowComponent } from './components/chat-window/chat-window.component';
import { UserChatWinodowComponent } from './components/user-chat-winodow/user-chat-winodow.component';
import { OverlayChatWindowComponent } from './components/overlay-chat-window/overlay-chat-window.component';

const routes: Routes = [
  // When you navigate to /chat, it will now load the ChatWindowComponent
  { path: '', component: ChatWindowComponent },
  { path: 'interview/:id', component: UserChatWinodowComponent }
  ,{ path: 'overlay', component: OverlayChatWindowComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ChatRoutingModule { }
